export default class IntroController {
	constructor({ text }) {
		this._text = text;
	}

	getText() {
		return this._text;
	}
}
